<template>
  <img v-lazy="gifteeForBusiness" alt="giftee for business" />
</template>
<script>
import GifteeForBusiness from '../../../../../images/giftee_for_business.png'
export default {
  data() {
    return {
      gifteeForBusiness: ''
    }
  },
  mounted() {
    this.gifteeForBusiness = GifteeForBusiness
  }
}
</script>
